"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogActionButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = require("../../../Button");
const Dialog_1 = require("../../designTokens/Dialog");
exports.StyledDialogActionButton = (0, styled_components_1.default)(Button_1.Button) `
    &[data-is-text-view='false'] {
        min-width: ${Dialog_1.dialogTokens.dialogActionButtonMinWidth.getVar()};
    }
`;
//# sourceMappingURL=DialogActionButton.styles.js.map